import { render, staticRenderFns } from "./b-ticket-time-info.vue?vue&type=template&id=45142294&scoped=true"
import script from "./b-ticket-time-info.vue?vue&type=script&lang=ts"
export * from "./b-ticket-time-info.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-time-info.vue?vue&type=style&index=0&id=45142294&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45142294",
  null
  
)

export default component.exports